import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './GallerySection.css';
import video1 from '../../assets/video-8.mp4';
import video2 from '../../assets/video-11.mp4';
// Replace with actual image paths
import img1 from '../../assets/party-1.JPG';
import img2 from '../../assets/party-2.JPG';
import img3 from '../../assets/party-3.JPG';
import img4 from '../../assets/party-4.JPG';
import img5 from '../../assets/party-5.JPG';
import img6 from '../../assets/party-6.JPG';
import img7 from '../../assets/party-7.JPG';
import img8 from '../../assets/corp-ev-1.JPG';
import img9 from '../../assets/corp-ev-2.JPG';
import img10 from '../../assets/corp-ev-3.JPG';
import img11 from '../../assets/corp-ev-4.JPG';
import img12 from '../../assets/gallery-12.jpeg';
import img13 from '../../assets/gallery-13.jpeg';
import img14 from '../../assets/gallery-14.jpeg';
import img15 from '../../assets/gallery-15.jpeg';
import img16 from '../../assets/gallery-16.jpeg';
import img17 from '../../assets/gallery-17.jpeg';
import img18 from '../../assets/gallery-18.jpeg';
import img19 from '../../assets/gallery-19.jpeg';
import img20 from '../../assets/gallery-20.jpeg';
import img21 from '../../assets/decor-1.jpg';
import img22 from '../../assets/decor-2.jpg';
import img23 from '../../assets/decor-3.jpg';
import img24 from '../../assets/decor-4.jpg';
import img25 from '../../assets/wed-1.jpg';
import img26 from '../../assets/wed-2.jpg';
import img27 from '../../assets/wed-3.jpg';
import img28 from '../../assets/wed-4.jpg';


const GallerySection = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="gallery-section py-5">
      <Container>
        <h2 className="text-center mb-5">Our Signature Aesthetic</h2>
        <div className="custom-gallery-layout">
          {[img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
            img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
            img21, img22, img23, img24, img25, img26, img27, img28]
            .map((img, idx) => (
              <div key={idx} className={`item item-${idx + 1}`} data-aos="fade-up">
                <img src={img} alt={`Gallery ${idx + 1}`} />
              </div>
          ))}

          {/* Video 1 */}
          <div className="item video-item" data-aos="fade-up">
            <video controls muted playsInline width="100%">
              <source src={video1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Video 2 */}
          <div className="item video-item" data-aos="fade-up">
            <video controls muted playsInline width="100%">
              <source src={video2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default GallerySection;
